import React from 'react'
import { SlideService } from '../../components/servicesListe/slideSerice'
import img from "../../assets/images/design.png"
import ServicesSection from '../../components/servicesListe/servicesSection'
import { DéveloppementIcon } from '../../assets/icons/DéveloppementIcon';
import { WebIcon } from '../../assets/icons/WebIcon';
import { MobileIcon } from '../../assets/icons/MobileIcon';
import { LogosIcon } from '../../assets/icons/LogosIcon';
import { CommunicationIcon } from '../../assets/icons/CommunicationIcon';
import { UXIcon } from '../../assets/icons/UXIcon';
import { PhotographieIcon } from '../../assets/icons/PhotographieIcon';

const services = [
  {
    title: "Logos & charte graphique",
    description: "Branding sur-mesure et ligne visuelle",
    icon: <LogosIcon />,
    variant: "white",
  },
  {
    title: "Supports de communication",
    description: "Affiches, brochures, présentations, flyers",
    icon: <CommunicationIcon />,
    variant: "green",
  },

  {
    title: "UX / UI Design",
    description: "Interfaces web et mobile centrées utilisateur",
    icon: <UXIcon />,
    variant: "green",
  },
 
    {
    title: "Photographie",
    description: "Shooting corporate, produits, portraits et ambiance",
    icon: <PhotographieIcon />,
    variant: "white",
  },

];
export const DesignPage

= () => {
  return (
    <div><SlideService title={"Design Graphique"}  description={"Une image forte. Une expérience fluide. Un impact immédiat."} img={img}/>
    
    
    <ServicesSection  services={services}/>
    </div>
  )
}
